import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { Modal, Status } from "@bitcine/cs-theme"
import { toggleModal } from "@api/shared_screeners/modals"
import { deleteSharedScreener } from "@api/shared_screeners"

const DeleteLinkConfirmation = ({ sharedScreener, status, deleteSharedScreener, toggleModal }) => {
  return (
    <Modal open title={"Delete Shared Screener Link"} onClose={() => toggleModal("delete")}> 
      <Status pending={status === "PENDING"} error={status === "ERROR"}>
        <div>
          <p>Are you sure you want to delete the shared screener link for <strong>{sharedScreener.shared_name}</strong>?</p>
          <div className='flex pt2 items-start justify-end'>
            <button
              onClick={() => deleteSharedScreener(sharedScreener._id)}
              className='cs-button ml1 small'
              disabled={status === "PENDING"}>
              Delete
            </button>
          </div>
        </div>
      </Status>
    </Modal>
  )
}

DeleteLinkConfirmation.propTypes = {
  sharedScreener: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
  deleteSharedScreener: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired
}

const mapStateToProps = ({ shared_screeners }) => ({
  sharedScreener: shared_screeners.modals.delete.sharedScreener,
  status: shared_screeners.modals.delete.status
})

const mapDispatchToProps = dispatch => ({
  deleteSharedScreener: bindActionCreators(deleteSharedScreener, dispatch),
  toggleModal: bindActionCreators(toggleModal, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(DeleteLinkConfirmation)
